<script setup lang="ts">
import { computed } from 'vue';
import { Host, useQuizterStore } from '@ilteducation/games';
import { useRoute, useRouter } from 'vue-router';
import { useLocale, useLocalisation } from '@/plugins/translation';

const route = useRoute();
const router = useRouter();
const { t } = useLocale();

// Load Quizter translations from the Quizter Lokalise project
const { includeAdditionalProject } = useLocalisation();
includeAdditionalProject('Quizter', false);

const gameId = route.params.gameId?.toString() ?? '';

const quizterStore = useQuizterStore();

const returnParams = computed(() => {
  if (quizterStore.returnParams) {
    return quizterStore.returnParams;
  }
  return {
    url: '/videos',
    text: t('back_to_videos'),
  };
});

const handleExit = () => {
  if (window.history.state?.back) {
    router.back();
    return;
  }

  // Fallback for direct navigation with no history: use the return URL.
  if (returnParams.value.url.startsWith('http')) {
    window.location.href = returnParams.value.url;
  } else {
    router.push(returnParams.value.url);
  }
};
</script>

<template>
  <Host :game-id="gameId" :return-params="returnParams" @exit="handleExit" />
</template>

<style scoped lang="scss"></style>
